// 사이트 푸터 내용 — 모든 고객 화면이 쓰는 흑연 브랜드 푸터의 사업자 정보·약관 링크.
// 사업자 정보는 회사 소개(ABOUT)와 함께 쓰므로 shared/config/company.ts 가 단일 원천이다.
import { PRIVACY_POLICY_PATH, TERMS_OF_SERVICE_PATH } from '@/shared/config';

export { COMPANY_FACTS } from '@/shared/config';

export interface FooterLink {
  readonly label: string;
  readonly path: string;
}

export const POLICY_LINKS: readonly FooterLink[] = [
  { label: '개인정보처리방침', path: PRIVACY_POLICY_PATH },
  { label: '이용약관', path: TERMS_OF_SERVICE_PATH },
];
